import { round, getSum, formatDollar } from '../../../dependencies/utilities.js';
import Chart from 'chart.js/auto';

import introJs from 'intro.js';

/////////////////// CHART FUNCTIONS /////////////////////////////

export function runTheNumbers() {

	var units = $('.units-hidden').val();

	// TARGET LINE DATA FOR THE CHARTS ( 52 WEEKS )
	var targetValue = Number( $( '#target-nitrogen' ).val() );

	var targetArray = [];
	var topEndArray = [];
	var lowEndArray = [];

	for ( i = 0; i < 52; i ++ ) {

		targetArray.push( targetValue );
		topEndArray.push( targetValue + ( targetValue / 2 ) );
		lowEndArray.push( targetValue - ( targetValue / 2 ) );

	}

	// RESET THE ARRAYS ( 78 WEEKS )
	var n_applied_g = [], product_g_ids = [],
		n_applied_f = [], product_f_ids = [],
		n_applied_sg = [], product_sg_ids = [],
		n_applied_tm = [], product_tm_ids = [];

	for ( i = 0; i <= 78; i ++ ) {

		n_applied_g[ i ] = [];
		product_g_ids[ i ] = [];
		n_applied_f[ i ] = [];
		product_f_ids[ i ] = [];
		n_applied_sg[ i ] = [];
		product_sg_ids[ i ] = [];
		n_applied_tm[ i ] = [];
		product_tm_ids[ i ] = [];

	}

	// loop through the scenario rows / applications.
	// calculate N applied, accumulate and record the product IDs

	//console.log(jsApplications);

	for ( i = 0; i < jsApplications.length; i ++ ) {

		var application = jsApplications[ i ];
		if ( application.visible ) {

			switch ( application.product.typeHandle ) {

				case 'granular':
					n_applied_g = build_n_applied( application, n_applied_g );
					product_g_ids = build_product_id( application, product_g_ids );
					break;
				case 'foliar':
					n_applied_f = build_n_applied( application, n_applied_f );
					product_f_ids = build_product_id( application, product_f_ids );
					break;
				case 'foliarSg':
					n_applied_sg = build_n_applied( application, n_applied_sg );
					product_sg_ids = build_product_id( application, product_sg_ids );
					break;
				case 'tankMix':
					n_applied_tm = build_n_applied( application, n_applied_tm );
					product_tm_ids = build_product_id( application, product_tm_ids );
					break;
				default:

			}

		}

	}

	//console.log(jsApplications);
	//console.log(n_applied_g);
	//console.log(product_g_ids);

	var releaseArrayG = build_releaseArray( n_applied_g, product_g_ids );
	var releaseArrayF = build_releaseArray( n_applied_f, product_f_ids );
	var releaseArraySG = build_releaseArray( n_applied_sg, product_sg_ids );
	//var releaseArrayTM = build_releaseArray( n_applied_tm, product_tm_ids );

	var resultsG = buildAvg( releaseArrayG, zone, typicalResponsesForType, 'granular' );
	var avgG = resultsG.avg;
	var tempEffects = resultsG.release_with_temp_effect;

	var resultsF = buildAvg( releaseArrayF, zone, typicalResponsesForType, 'foliar' );
	var avgF = resultsF.avg;

	var resultsSG = buildAvg( releaseArraySG, zone, typicalResponsesForType, 'foliar-sg' );
	var avgSG = resultsSG.avg;

	//var resultsTM = buildAvg( releaseArrayTM, zone, typicalResponsesForType, 'tank-mix' );
	//var avgTM = resultsTM.avg;

	var avgL = sumAvg( avgF, avgSG );

	var coldArray = getColds( zone );

	// why??
	//avgG.shift()

	// some carryover arrays
	var tempCO = [];
	var avgCO = [];

	// add the average N arrays (granular and liquid) together temporarily
	for ( i = 0; i < 78; i ++ ) {
		tempCO[ i ] = avgG[ i ] + avgL[ i ];
		tempCO[ i ] = round( tempCO[ i ], 3 );
	}

	// bust the carryover curve out, index 0
	for (var i=0;i<tempCO.length;i++) {
		if( i > 51) {
			avgCO.push(tempCO[i]);
		}
	}

	// how much N is in that curve? / on the ground
	var carryoverSum = avgCO.reduce( getSum );
	carryoverSum = round( carryoverSum, 2 )

	// for the display
	$('.carryover-amt').text(carryoverSum)

	// display and populate the hidden fields. for the save.
	if ( carryoverSum == 0 ) {
		$('#carryover-hud').removeClass('active')
		$('.has-carryover-hidden').val(0)
		$('.carryover-out-hidden').val(null)
		$('.carryover-out-profile-hidden').val('')
	} else {
		$('#carryover-hud').addClass('active')
		$('.has-carryover-hidden').val(1)
		$('.carryover-out-hidden').val(carryoverSum)
		$('.carryover-out-profile-hidden').val( JSON.stringify(avgCO) )
	}

	// *********** prior to this point 'carryover' means carryover OUT
	// the CO we want to plot on the graph = carryover IN

	var carryoverSumin = $('.carryover-in-hidden').val()
	var str = $('.carryover-in-profile-hidden').val()
	var avgCOin = str.length ? JSON.parse(str) : []

	if ( units == 'imperial' ) {

		// imperial is default
		// all of these results are lbs/1000 ft^2
		// EXCEPT targetValue and targetArray

		var results = {
			"avgG": avgG,
			"avgCO": avgCOin,
			"avgL": avgL,
			"coldArray": coldArray,
			"tempEffects": tempEffects,
			"targetValue": targetValue,
			"targetArray": targetArray,
			"topEndArray": topEndArray,
			"lowEndArray": lowEndArray,
			"carryOver": carryoverSumin,
			"units": units
		};

		// NOTES //////
		/// check for rounding errors if chart starts acting wonky
		//console.log(n_applied_f);
		//console.log(product_f_ids);
		//console.log(avgG);

	} else {

		var results = {
			"avgG": nReleaseToMetric(avgG),
			"avgCO": nReleaseToMetric(avgCOin),
			"avgL": nReleaseToMetric(avgL),
			"coldArray": nReleaseToMetric(coldArray),
			"tempEffects": nReleaseToMetric(tempEffects),
			"targetValue": targetValue,
			"targetArray": targetArray,
			"topEndArray": topEndArray,
			"lowEndArray": lowEndArray,
			"carryOver": nReleaseToMetric(carryoverSumin),
			"units": units
		};

	}

	return results;

}

function build_n_applied( application, n_applied ) {

	// case "granular":"lbs/1000 ft<sup>2</sup>";
	// case "foliar / mix":"oz/1000 ft<sup>2</sup>";
	// case "foliarSg":"lbs/acre";

	var units = $('.units-hidden').val();

	var week = application.week;
	var product = application.product;
	var rate = application.weight;

	if ( product.typeHandle == 'granular' ) {

		if ( units == "metric" ) {
			rate = application.weight * 2.0482;
		}

		var temp = ( product.nutrients[ 'nitrogen' ] * rate ) / 100; 
		n_applied[ Number(week) ].push( temp );

	}

	if ( product.typeHandle == 'foliarSg' ) {

		if ( units == "metric" ) {
			rate = application.weight * .892179;
		}

		var temp = ( product.nutrients[ 'nitrogen' ] * rate * .022956 ) / 100; // convert
		n_applied[ week ].push( temp );

	}

	if ( product.typeHandle == 'foliar' || product.typeHandle == 'tankMix' ) {


		if ( units == "metric" ) {
			rate = application.weight * .305151727;
		}

		var temp = ( product.nutrients[ 'nitrogen' ] * rate * product.sg ) / 1600; // convert
		n_applied[ week ].push( temp );

	}

	return n_applied;

}

function build_product_id( application, product_ids ) {


	product_ids[ Number(application.week) ].push( application.product.id );

	return product_ids;

}

function build_releaseArray( n_applied, product_ids ) {

	var releaseArray = [];
	var weekrelease = [];

	for ( var i = 0; i <= 78; i ++ ) {

		releaseArray[ i ] = [];
		weekrelease[ i ] = [];
		for ( var j = 0; j <= 78; j ++ ) {
			releaseArray[ i ][ j ] = 0; // 79 by 79 array init with 0 for storing arrays for products used during 78 weeks
			weekrelease[ i ][ j ] = 0;

		}

	}

	/// slight departure from original algorthm. we are adjusting for multiple products on same week.
	/// look at the prodyct ids for the week (now an array)
	// and make weekrelease additive

	for ( var wk_counter = 0; wk_counter <= 78; wk_counter ++ ) {

		if ( ! $.isEmptyObject( product_ids[ wk_counter ] ) ) {

			// looping throught all products for *this* week
			for ( var m = 0; m < product_ids[ wk_counter ].length; m ++ ) {

				var productId = product_ids[ wk_counter ][ m ];
				var appliedN = n_applied[ wk_counter ][ m ];

				// all this to find the release profile for a productId???
				for ( var p = 0; p < jsApplications.length; p ++ ) {

					var row = jsApplications[ p ];
					if ( row.product.id == productId ) {

						var row_weekrelease = row.product.releaseProfile;

					}

				}


				for ( var i = 0; i <= 78; i ++ ) {

					// cumulative
					weekrelease[ wk_counter ][ i ] = weekrelease[ wk_counter ][ i ] + row_weekrelease[ i ] * appliedN / 100;
					weekrelease[ wk_counter ][ i ] = round( weekrelease[ wk_counter ][ i ], 4 );

					var k = wk_counter;
					var l = 1;

					while ( k <= 78 ) {

						releaseArray[ wk_counter ][ k ] = weekrelease[ wk_counter ][ l ];
						l ++;
						k ++;

					}

				}

			}

		}

	}

	// release array is ON THE MONEY!
	return releaseArray;

}

function buildAvg( releaseArray, zone, typicalResponse, type ) {


	var related_temp_percentage = [];
	//related_temp_percentage[ 0 ] = 0; // no zero index?
	//related_temp_percentage[ 1 ] = 0; // what?

	for ( var i = 0; i <= 78; i ++ ) {

		// loop back to day 1 to repeat the temperature profile. after 52 weeks
		if ( i > 51 ) {
			related_temp_percentage[ i ] = getPercentageFor( round( zone[ i - 52 ].averageTemperature,0 ) );
		} else {
			related_temp_percentage[ i ] = getPercentageFor( round( zone[ i ].averageTemperature,0 ) );
		}

	}

	var avg = [], release_with_temp_effect = [], total_srn = [];

	for ( var i = 0; i <= 78; i ++ ) {

		avg[ i ] = 0;
		release_with_temp_effect[ i ] = 0;
		total_srn[ i ] = 0;

	}

	var typical_response_a = [];
	var typical_response_b = [];
	var typical_response_c = [];
	var typical_response_d = [];
	var typical_response_e = [];

	for ( var i = 0; i <= 78; i ++ ) {

		typical_response_a[ i ] = 0;
		typical_response_b[ i ] = 0;
		typical_response_c[ i ] = 0;
		typical_response_d[ i ] = 0;
		typical_response_e[ i ] = 0;

	}

	var remaining_nitrogen = [];

	for ( var t1 = 0; t1 <= 78; t1 ++ ) {	

		for ( var t2 = 0; t2 <= 78; t2 ++ ) {

			// account for any long tail of nothings
			if (  isNaN(releaseArray[ t2 ][ t1 ]) ) {
				releaseArray[ t2 ][ t1 ] = 0
			};

			total_srn[ t1 ] = total_srn[ t1 ] + releaseArray[ t2 ][ t1 ];
			total_srn[t1] = round(total_srn[t1],3)

		}		

		release_with_temp_effect[ t1 ] = total_srn[ t1 ] * related_temp_percentage[ t1 ] / 100;
		release_with_temp_effect[ t1 ] = round(release_with_temp_effect[ t1 ],3)

		remaining_nitrogen[ t1 ] = total_srn[ t1 ] - release_with_temp_effect[ t1 ];
		total_srn[ t1 + 1 ] = total_srn[ t1 + 1 ] + remaining_nitrogen[ t1 ];

	}

	var typical_releaseweek1 = typicalResponse[ type ][ 0 ];
	var typical_releaseweek2 = typicalResponse[ type ][ 1 ];
	var typical_releaseweek3 = typicalResponse[ type ][ 2 ];
	var typical_releaseweek4 = typicalResponse[ type ][ 3 ];
	var typical_releaseweek5 = typicalResponse[ type ][ 4 ];
	for ( var i = 0; i <= 78; i ++ ) {

		typical_response_a[ i ] = typical_response_a[ i ] + release_with_temp_effect[ i ] * typical_releaseweek1 / 100;
		typical_response_b[ i + 1 ] = typical_response_b[ i + 1 ] + release_with_temp_effect[ i ] * typical_releaseweek2 / 100;
		typical_response_c[ i + 2 ] = typical_response_c[ i + 2 ] + release_with_temp_effect[ i ] * typical_releaseweek3 / 100;
		typical_response_d[ i + 3 ] = typical_response_d[ i + 3 ] + release_with_temp_effect[ i ] * typical_releaseweek4 / 100;
		typical_response_e[ i + 4 ] = typical_response_e[ i + 4 ] + release_with_temp_effect[ i ] * typical_releaseweek5 / 100;
						
		avg[ i ] = ( typical_response_a[ i ] + typical_response_b[ i ] + typical_response_c[ i ] + typical_response_d[ i ] + typical_response_e[ i ] ) / 5;
		avg[ i ] = 5 * avg[ i ];
		avg[ i ] = round( avg[ i ], 3 );

	}

	var results = {
		"avg": avg,
		"release_with_temp_effect": release_with_temp_effect
	};

	return results;

}

function sumAvg( avgF, avgSG ) {

	var avg = [];

	for ( var i = 0; i <= 78; i ++ ) {

		avg[ i ] = avgF[ i ] + avgSG[ i ];
		avg[ i ] = round( avg[ i ], 3 );

	}

	avg.shift()

	return avg;

}

function getColds( zone ) {

	var avg = [];

	for ( var i = 0; i <= 51; i ++ ) {

		avg[ i ] = zone[ i ][ "coldRelease" ];

	}

	return avg;

}

export function reChart( targetValue ) {

	chart.destroy();
	pdfChart.destroy();

	var targetArray = [];
	var topEndArray = [];
	var lowEndArray = [];

	for ( var i = 0; i < 52; i ++ ) {

		targetArray.push( targetValue );
		topEndArray.push( targetValue + ( targetValue / 2 ) );
		lowEndArray.push( targetValue - ( targetValue / 2 ) );

	}

	config.data.datasets.forEach( function ( dataset, index ) {

		switch ( index ) {

			case 4:
				dataset.data = targetArray;
				break;
			case 5:
				dataset.data = topEndArray;
				break;
			case 6:
				dataset.data = lowEndArray;
				break;
			default:

		}

	} );

	// pdfChartConfig.data.datasets.forEach( function ( dataset, index ) {
	//
	// 	switch ( index ) {
	//
	// 		case 3:
	// 			dataset.data = targetArray;
	// 			break;
	// 		case 4:
	// 			dataset.data = topEndArray;
	// 			break;
	// 		case 5:
	// 			dataset.data = lowEndArray;
	// 			break;
	// 		default:
	//
	// 	}
	//
	// } );

	// when and if ANDE decides to turn some chart data back on...

	//config.options.scales.yAxes[ 0 ].ticks.max = 2 * targetValue;
	//config.options.scales.yAxes[ 1 ].ticks.max = 2 * targetValue;
	//config.options.scales.yAxes[ 1 ].ticks.stepSize = ( targetValue / 3 );

	config.options.scales.y.ticks.stepSize = ( targetValue / 3 );
	//pdfChartConfig.options.scales.yAxes[ 0 ].ticks.stepSize = ( targetValue / 3 );

	chart = new Chart( canvas, config );
	pdfChart = new Chart(pdfCanvas, config);

}

export function updateChart( data ) {

	config.data.datasets.forEach( function ( dataset, index ) {

		switch ( index ) {

			case 0:
				var temp = []
				var el =  document.getElementById("row-carryover");
				if (!el || el.classList.contains("hidden") ) {
					// zero out the array
					for ( var i = 0; i <= 26; i ++ ) {
						temp.push('0')
					}
					dataset.data = temp;
				} else {
					// re-apply the carryover curve
					dataset.data = data.avgCO;
				};
				break;
			case 1:
				dataset.data = data.avgG;
				break;
			case 2:
				dataset.data = data.avgL;
				break;
			case 3:
				dataset.data = data.coldArray;
				break;
			case 4:
				dataset.data = data.targetArray;
				break;
			case 5:
				dataset.data = data.topEndArray;
				break;
			case 6:
				dataset.data = data.lowEndArray;
				break;
			case 7:
				dataset.data = data.tempEffects;
				break;
			default:

		}

	} );

	chart.update();
	pdfChart.update();

}

///////////////////////////////////////////////

export function updateRows() {

	//$('#save-scenario').addClass('dirty');

	var units = $('.units-hidden').val();
	var country = $('.country-hidden').val();

	/// BAGS

	var bagCells = $( 'tr:not(.hidden) .bags' );

	var totalBags = 0;

	for ( var i = 0; i < bagCells.length; i ++ ) {

		var bagCell = $( bagCells[ i ] );
		var rowId =	bagCell.parents( 'tr' ).attr( 'id' );
		var rowWeight = $('#'+rowId+' input.row-weight-input').val();

		if ( bagCell.attr( 'data-type' ) == "granular" ) {
			
			if ( units == "imperial" && country == "canada" ) {
				var bagWeight = bagCell.attr( 'data-product-weight' ) * 2.20462;
			} else if (  units == "metric" && country == "us") {
				var bagWeight = ( bagCell.attr( 'data-product-weight' ) ) / 2.20462 ;
			} else {
				var bagWeight = bagCell.attr( 'data-product-weight' )
			}

			bagWeight = round( bagWeight, 1 );

			// console.log("BAG WEIGHT: " + bagWeight)
			// console.log("ROW WEIGHT: " + rowWeight )
			// console.log("PRODUCT WEIGHT: " + bagCell.attr( 'data-product-weight' ) )

			if ( units == 'metric' ) {
				var bags = (rowWeight / bagWeight ) * 100;
			} else {
				var bags = rowWeight * $( '#coverage' ).val() * 43.56 / bagWeight;
			}
			bags = round( bags, 1 );
			totalBags = totalBags + bags;

		} else if ( bagCell.attr( 'data-type' ) == "foliarSg" ) {

			//constant here formerly, was 2.0482 ?

			if ( units == "imperial" && country == "canada") {
				var bagWeight = bagCell.attr( 'data-product-weight' ) * 2.20462;
			} else if (  units == "metric" && country == "us") {
				var bagWeight = bagCell.attr( 'data-product-weight' ) / 2.20462;
			} else {
				var bagWeight = bagCell.attr( 'data-product-weight' )
			}

			bagWeight = round( bagWeight, 1 );

			// console.log("BAG WEIGHT: " + bagWeight)
			// console.log("ROW WEIGHT: " + rowWeight )
			// console.log("PRODUCT WEIGHT: " + bagCell.attr( 'data-product-weight' ) )

			if ( units == 'metric' ) {
				var bags = (rowWeight / bagWeight );
			} else {
				var lbssg = rowWeight / 43.56;
				lbssg = round( lbssg, 3 );
				//var bags = rowWeight * $( '#coverage' ).val() * 43.56 / bagWeight;
				var bags = lbssg * $( '#coverage' ).val() * 43.56 / bagWeight;
			}

			bags = round( bags, 1 );
			totalBags = totalBags + bags;

		} else {

			var bags = "--";

		}

		bagCell.html( bags );

	}

	$( '.total-bags' ).html( round(totalBags,1) );

	/// GALLONS

	var gallonCells = $( 'tr:not(.hidden) .gallons' );

	var totalGals = 0;

	for ( i = 0; i < gallonCells.length; i ++ ) {

		var gallonCell = $( gallonCells[ i ] );
		var rowId =	gallonCell.parents( 'tr' ).attr( 'id' );
		var rowWeight = $('#'+rowId+' input.row-weight-input').val();

		// if ( units == "metric" ) {
		// 	rowWeight = rowWeight * .305151727;
		// }

		if ( gallonCell.attr( 'data-type' ) == "foliar" || gallonCell.attr( 'data-type' ) == "tankMix" ) {

			var gallons = rowWeight * $( '#coverage' ).val() * 43.56 / 128;
			gallons = round( gallons, 0 );
			totalGals = totalGals + gallons;

		} else {

			var gallons = "--";

		}

		gallonCell.html( gallons );

	}

	$( '.total-gallons' ).html( totalGals );

	/// TD ELEMENTS (N-P-K)

	var nutrientCells = $( 'tr:not(.hidden) td.nutrient' );

	for ( i = 0; i < nutrientCells.length; i ++ ) {

		var nutrientCell = $( nutrientCells[ i ] );
		var rowId =	nutrientCell.parents( 'tr' ).attr( 'id' );
		var rowWeight = $('#'+rowId+' input.row-weight-input').val();

		if ( nutrientCell.attr( 'data-type' ) == "granular" ) {

			// if ( units == "metric" ) {
			// 	rowWeight = rowWeight * 2.0482
			// }

			// if ( units == "imperial" && country == "canada" ) {
			// 	var rowWeight = rowWeight * 02.0482;
			// }
			
			// if (  units == "metric" && country == "us" ) {
			// 	var rowWeight = rowWeight / 02.0482;
			// }

			var nutrient = rowWeight * nutrientCell.attr( 'data-amount' ) / 100;
			nutrient = round( nutrient, 3 );

		} else if ( nutrientCell.attr( 'data-type' ) == "foliar" || nutrientCell.attr( 'data-type' ) == "tankMix" ) {

			// if ( units == "metric" ) {
			// 	rowWeight = rowWeight * .305151727
			// }

			var nutrient = ( rowWeight / 16 ) * nutrientCell.attr( 'data-sg' ) * nutrientCell.attr( 'data-amount' ) / 100;
			nutrient = round( nutrient, 3 );

		} else if ( nutrientCell.attr( 'data-type' ) == "foliarSg" ) {

			if ( units == "metric" ) {
				rowWeight = rowWeight / 2.20462
			}

			// console.log("ROW WEIGHT: " + rowWeight)
			// console.log("AMOUNT: " + nutrientCell.attr( 'data-amount' ))

			//var nutrient = ( rowWeight * .022956 ) * nutrientCell.data( 'sg' ) * nutrientCell.data( 'amount' ) / 100;
			var nutrient = ( rowWeight * .022956 ) * ( nutrientCell.attr( 'data-amount' ) / 100 );
			nutrient = round( nutrient, 3 );

		} else if ( nutrientCell.attr( 'data-type' ) == "carryover" ) {

			nutrient = nutrientCell.attr( 'data-amount' );

		} else {

			var nutrient = "--";

		}

		nutrientCell.html( nutrient );

	}

	/// INPUT ELEMENTS (ALL nutrients)

	var nutrientCells = $( 'tr:not(.hidden) input.nutrient' );

	for ( i = 0; i < nutrientCells.length; i ++ ) {

		var nutrientCell = $( nutrientCells[ i ] );
		var rowId =	nutrientCell.parents( 'tr' ).attr( 'id' );
		var rowWeight = $('#'+rowId+' input.row-weight-input').val();

		if ( nutrientCell.attr( 'data-type' ) == "granular" ) {

			// if ( units == "metric" ) {
			// 	rowWeight = rowWeight * 02.0482;
			// }

			var nutrient = rowWeight * nutrientCell.attr( 'data-amount' ) / 100;
			nutrient = round( nutrient, 3 );

		} else if ( nutrientCell.attr( 'data-type' ) == "foliar" || nutrientCell.attr( 'data-type' ) == "tankMix" ) {

			// if ( units == "metric" ) {
			// 	rowWeight = rowWeight * 0.305151727;
			// }

			var nutrient = ( rowWeight / 16 ) * nutrientCell.attr( 'data-sg' ) * nutrientCell.attr( 'data-amount' ) / 100;
			nutrient = round( nutrient, 3 );

		} else if ( nutrientCell.attr( 'data-type' ) == "foliarSg" ) {

			if ( units == "metric" ) {
				rowWeight = rowWeight / 2.20462
			}
			
			//var nutrient = ( rowWeight * .022956 ) * nutrientCell.data( 'sg' ) * nutrientCell.data( 'amount' ) / 100;
			var nutrient = ( rowWeight * .022956 ) * ( nutrientCell.attr( 'data-amount' ) / 100 );
			nutrient = round( nutrient, 3 );


		} else if ( nutrientCell.attr( 'data-type' ) == "carryover" ) {

			nutrient = nutrientCell.attr( 'data-amount' );

		} else {

			var nutrient = "--";

		}

		nutrientCell.val( nutrient );

	}

	// nutrient totals

	calcNutrientTotals( 'nitrogen' );
	calcNutrientTotals( 'phosphorous' );
	calcNutrientTotals( 'potassium' );
	calcNutrientTotals( 'calcium' );
	calcNutrientTotals( 'magnesium' );
	calcNutrientTotals( 'manganese' );
	calcNutrientTotals( 'iron' );
	calcNutrientTotals( 'copper' );
	calcNutrientTotals( 'zinc' );
	calcNutrientTotals( 'humic' );

	// COST

	var costCells = $( 'tr:not(.hidden) .cost' );

	var totalCost = 0;

	costCells.each( function ( i ) {

		var costCell = $( costCells[ i ] );
		var rowId = costCell.parents( 'tr' ).attr( 'id' );

		//var price = $( '#' + rowId + ' .product-select :selected' ).data( 'product-price' );
		var price = $( '#' + rowId + ' .row-price-input' ).val();
		var bags = $( '#' + rowId + ' .bags' ).html();
		var gallons = $( '#' + rowId + ' .gallons' ).html();

		if ( bags != "--" ) {

			var cost = price * bags;

		}

		if ( gallons != "--" ) {

			var cost = price * gallons;

		}

		if ( cost ) {

			cost = round( cost, 2 );
			totalCost = totalCost + cost;
			cost = formatDollar( cost );

		} else {

			cost = "--";

		}

		costCell.html( cost );

	} );

	$( '.total-cost' ).html( formatDollar( totalCost ) );

	//////// SUMMARY

	var rows = $('#scenario-table tbody tr:not(#row-carryover, .hidden)')
	
	var oldGranularProductTitle;
	var oldFoliarProductTitle;
	var oldFoliarSgProductTitle;

	var bagCount = 0
	var granular = []
	var galCount = 0
	var foliar = []
	var bagSgCount = 0
	var foliarSg = []

	var costGranularCount = 0
	var costFoliarCount = 0
	var costFoliarSgCount = 0


	rows.each(function() {
		var productTitle = $(this).find('.product-title').text()
		var partCode = $(this).find('.part-code').text()
		var partCodeLegacy = $(this).find('.part-code-legacy').text()
		var productType = $(this).find('.bags').attr( 'data-type' )

		var table = $('#scenario-table').DataTable();
		// check for an empty data table
		if ( table.data().any() ) {

			var rowBags = $(this).find('.bags').text()
			var rowGals = $(this).find('.gallons').text()
			var rowCost = $(this).find('.cost').text()

			if ( productType == "granular" ) {
				
				if (  !(productTitle in granular) ) {
					// start a new product array, reset the count
					granular[productTitle] = []
					bagCount = 0
					costGranularCount = 0
				} else {
					bagCount = granular[productTitle]['bags']
					costGranularCount = granular[productTitle]['cost']
				}

				if (rowBags!="--") {
					bagCount = Number(bagCount) + Number(rowBags)
				}

				rowCost=rowCost.replace(/\,/g,'');
				//rowCost=parseInt(rowCost,10);

				if (rowCost!="--") {
					costGranularCount = Number(costGranularCount) + Number(rowCost)
				}

				granular[productTitle]['bags'] = round(bagCount,2);
				granular[productTitle]['cost'] = costGranularCount;
				granular[productTitle]['partCode'] = partCode;
				granular[productTitle]['partCodeLegacy'] = partCodeLegacy;

				oldGranularProductTitle = productTitle

			}

			if ( productType == "foliarSg" ) {

				//console.log("productTitle" in foliarSg); // true, regardless of the actual value
				
				if (  !(productTitle in foliarSg) ) {
					// start a new product array, reset the count
					foliarSg[productTitle] = []
					bagSgCount = 0
					costFoliarSgCount = 0
				} else {
					bagSgCount = foliarSg[productTitle]['bags']
					costFoliarSgCount = foliarSg[productTitle]['cost']
				}

				if (rowBags!="--") {
					bagSgCount = Number(bagSgCount) + Number(rowBags)
				}

				rowCost=rowCost.replace(/\,/g,'');

				if (rowCost!="--") {
					costFoliarSgCount = Number(costFoliarSgCount) + Number(rowCost)
				}
		
				foliarSg[productTitle]['bags'] = round(bagSgCount,2);
				foliarSg[productTitle]['cost'] = costFoliarSgCount;
				foliarSg[productTitle]['partCode'] = partCode;
				foliarSg[productTitle]['partCodeLegacy'] = partCodeLegacy;
				
				oldFoliarSgProductTitle = productTitle

			}

			if ( productType == "foliar" ) {
				
				if (  !(productTitle in foliar) ) {
					// start a new product array, reset the count
					foliar[productTitle] = []
					galCount = 0
					costFoliarCount = 0
				} else {
					galCount = foliar[productTitle]['gals']
					costFoliarCount = foliar[productTitle]['cost']
				}

				if (rowGals!="--") {
					galCount = galCount + Number(rowGals)
				}

				rowCost=rowCost.replace(/\,/g,'');

				if (rowCost!="--") {
					costFoliarCount = Number(costFoliarCount) + Number(rowCost)
				}
		
				foliar[productTitle]['gals'] = round(galCount,2);
				foliar[productTitle]['cost'] = costFoliarCount;
				foliar[productTitle]['partCode'] = partCode;
				foliar[productTitle]['partCodeLegacy'] = partCodeLegacy;
				
				oldFoliarProductTitle = productTitle
			}

		}

	});

	var html = ''

	for(var key in granular) {
		if ( granular[key]['bags'] > 0) {
			html += '<article class="summary-item">'
			html += '<p class="summary-product-title">'+key+'</p>'
			html += '<p class="summary-part-code">'+granular[key]['partCodeLegacy']+' / '+granular[key]['partCode']+'</p>'
			html += '<p class="summary-qty-cost">'+granular[key]['bags'] + ' bags'
			if ( granular[key]['cost']  != "0.00") {
				html += ' / $' + formatDollar(granular[key]['cost'],2) 
			}
			html += '</p>'
			html += '</article>'
		}
	}

	for(var key in foliar) {
		if ( foliar[key]['gals']  > 0) {
			html += '<article class="summary-item">'
			html += '<p class="summary-product-title">'+key+'</p>'
			html += '<p class="summary-part-code">'+foliar[key]['partCodeLegacy']+' / '+foliar[key]['partCode']+'</p>'
			html += '<p class="summary-qty-cost">'+foliar[key]['gals'] + ' gallons'
			if ( foliar[key]['cost']  != "0.00") {
				html += ' / $' + formatDollar(foliar[key]['cost'],2)
			}
			html += '</p>'
			html += '</article>'
		}
	}

	for(var key in foliarSg) {
		if ( foliarSg[key]['bags']  > 0) {
			html += '<article class="summary-item">'
			html += '<p class="summary-product-title">'+key+'</p>'
			html += '<p class="summary-part-code">'+foliarSg[key]['partCodeLegacy']+' / '+foliarSg[key]['partCode']+'</p>'
			html += '<p class="summary-qty-cost">'+foliarSg[key]['bags'] + ' bags'
			if ( foliarSg[key]['cost']  != "0.00") {
				html += ' / $' + formatDollar(foliarSg[key]['cost'],2)
			}
			html += '</p>'
			html += '</article>'
		}
	}

	$('#summary').html(html);
}

function calcNutrientTotals( nutrient ) {

	var cells = $( 'tr:not(.hidden) input.' + nutrient );
	var total = 0;

	for ( var i = 0; i < cells.length; i ++ ) {

		var cell = $( cells[ i ] );
		var value = Number( cell.val() );
		total = total + value;

	}

	$( '.total-' + nutrient ).html( round( total, 3 ) );

}

//////// DEPRECATED ?????????? ////////////////////
function makeNewRowFOO( products ) {

	$('#save-scenario').addClass('dirty');

	var showPricing = $('.show-pricing-hidden').val()
	var units = $('.units-hidden').val()
	var defaultWeight = '0.0';
	var selectWeek = latestWeek()
	var sortWeek = selectWeek + 1

	if (sortWeek.toString().length == 1) {
    	sortWeek = "0" + sortWeek;
  	}

	// build the new row html. whew. hold tight.

	var html = '<tr id="new_' + newRowCount + '">';
	html += '<td class="revealer"></td>';
	html += '<input type="hidden" name="fields[applicationsMatrix][new_' + newRowCount + '][type]" value="' + products[ 0 ].typeHandle + '">';
	html += '<input type="hidden" name="fields[applicationsMatrix][new_' + newRowCount + '][enabled]" value="1">';
	html += '<td data-order="'+sortWeek+'">';
	html += '<select class="product-week-select select-two" name="fields[applicationsMatrix][new_' + newRowCount + '][fields][week]">';

	for ( i = 0; i < weeksArray.length; i ++ ) {

		var week = weeksArray[ i ];

		if ( i == selectWeek ) { // 0 index

			html += '<option value="' + ( i + 1 ) + '" selected>' + week + '</option>'; // there is no week 0

		} else {

			html += '<option value="' + ( i + 1 ) + '">' + week + '</option>'; // there is no week 0

		}

	}

	html += '</select>';
	html += '</td>';
	html += '<td>' + ( products[ 0 ].type == "Foliar SG" ? 'Foliar' : products[ 0 ].type ) + '</td>';
	html += '<td align="left">';
	html += '<div class="visible-md-up">'
	html += '<select class="product-select select-two" data-placeholder="Select A Product..." data-product-type="' + products[ 0 ].typeHandle + '">';

	html += '<option></option>';

	for ( i = 0; i < products.length; i ++ ) {

			html += '<option value="' + products[ i ].id + '" data-product-price="' + products[ i ].price + '">' + products[ i ].linkCode + '</option>';

	}

	if ( units == "imperial" ) {

		switch ( products[ 0 ].typeHandle ) {

			case "granular":
				var weightUnit = "lbs/1000 ft<sup>2</sup>";
				break;
			case "foliar":
			case "tankMix":
				var weightUnit = "oz/1000 ft<sup>2</sup>";
				break;
			case "foliarSg":
				var weightUnit = "lbs/acre";
				break;

		}

	} else {

		switch ( products[ 0 ].typeHandle ) {

			case "granular":
				var weightUnit = "kg/100m<sup>2</sup>";
				break;
			case "foliar":
			case "tankMix":
				var weightUnit = "l/ha";
				break;
			case "foliarSg":
				var weightUnit = "kg/ha";
				break;

		}

	}


	html += '</select>';
	html += '</div>'
	html += '<input type="hidden" class="product-id-row-new_' + newRowCount + '" name="fields[applicationsMatrix][new_' + newRowCount + '][fields][product][]" value="' + products[ 0 ].id + '">';
	html += '<div class="read-only-details visible-md-down">'+
						'<div class="product-week">'+weeksArray[selectWeek]+'</div>'+
						'<div class="product-title">Select a product and configure application settings in the <i class="far fa-edit"></i> detail view.</div>'+
						'<div class="product-type">'+ ( products[ 0 ].type == "Foliar SG" ? 'Foliar' : products[ 0 ].type ) +' - <span class="row-weight">'+defaultWeight+'</span> <span class="weight-unit">'+weightUnit+'</span></div>'+
					'</div>'

	html += '</div>';
	html += '</td>';

	// product info
	html += '<td class="product-info text-center">'
	html += '<span class="part-code hidden">'+products[ 0 ].productCodeNew+'</span>'

	html += '<span class="product-detail-title hidden">'+products[ 0 ].title+'</span>'
	html += '<span class="product-detail-description hidden">'+products[ 0 ].description+'</span>'
	html += '<span class="product-category hidden">'+products[ 0 ].productCategory+'</span>'
	html += '<span class="label-url hidden">'+products[ 0 ].labelUrl+'</span>'
	html += '<span class="product-weight hidden">'+products[ 0 ].weight+'</span>'
	html += '<span class="product-country hidden">'+ products[ 0 ].country +'</span>'
	html += '<span class="product-sgn hidden">'+products[ 0 ].sgn+'</span>'

	html += '<btn data-dismiss="modal" data-toggle="modal" data-target="#product-info-modal" class="btn btn-info btn-circle btn-product-info disabled"><i class="fas fa-info"></i></btn></td>';

	// rate // weight
	html += '<td><input type="text" min="0" class="row-weight-input" name="fields[applicationsMatrix][new_' + newRowCount + '][fields][weight]" size="4" value="' + defaultWeight + '"/> <span class="caption weight-unit">' + weightUnit + '</span></td>';

	// bags gallons
	html += '<td class="bags text-center" data-type="' + products[ 0 ].typeHandle + '" data-row-weight="' + defaultWeight + '" data-product-weight="' + products[ 0 ].weight + '"></td>';
	html += '<td class="gallons text-center" data-type="' + products[ 0 ].typeHandle + '" data-row-weight="' + defaultWeight + '">--</td>';

	// cost
	if ( showPricing=="1"){
	html += '<td class="text-center"><input type="text" min="0" class="row-price-input" name="fields[applicationsMatrix][new_' + newRowCount + '][fields][price]" size="5" value="0.00"/></td>'
	html += '<td class="cost text-center"></td>';
	}

	// NPK
	html += '<td class="nutrient nitrogen text-center" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.nitrogen + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '">--</td>';
	html += '<td class="nutrient phosphorous text-center" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.phosphorous + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '">--</td>';
	html += '<td class="nutrient potassium text-center" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.potassium + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '">--</td>';

	// hidden Nutrients
	html += '<input type="hidden" class="nutrient nitrogen" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.nitrogen + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
	html += '<input type="hidden" class="nutrient phosphorous" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.phosphorous + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
	html += '<input type="hidden" class="nutrient potassium" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.potassium + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
	html += '<input type="hidden" class="nutrient calcium" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.calcium + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
	html += '<input type="hidden" class="nutrient magnesium" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.magnesium + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
	html += '<input type="hidden" class="nutrient manganese" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.manganese + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
	html += '<input type="hidden" class="nutrient iron" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.iron + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
	html += '<input type="hidden" class="nutrient copper" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.copper + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
	html += '<input type="hidden" class="nutrient zinc" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.zinc + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
	html += '<input type="hidden" class="nutrient humic" data-type="' + products[ 0 ].typeHandle + '" data-amount="' + products[ 0 ].nutrients.humic + '" data-sg="' + products[ 0 ].sg + '" data-row-weight="' + defaultWeight + '" value=""/>';

	// controls
	html += '<td class="text-right controls">'
	html += '<btn data-dismiss="modal" data-toggle="modal" data-target="#row-copy-modal" class="btn row-copy"><i class="far fa-copy"></i></btn> '
	html += '<i class="fas fa-eye toggle-row-visibility"></i> '
	html += '<btn class="btn btn-danger btn-circle row-delete"><i class="fas fa-times"></i></btn>'
	html += '</td>';

	html += '<input class="row-visible" type="hidden" name="fields[applicationsMatrix][new_' + newRowCount + '][fields][visible]" value="1"/>'

	html += '</tr>';

	// is the datatable "add products..." row showing? yes? remove it...
	if ( $('.dataTables_empty').length ) {
		$('.dataTables_empty').closest( "tr" ).remove();
	}

	// now update the scenario data and update the graph

	// week limit
	if ( Number(selectWeek) == 52 ) {
		var week = Number(selectWeek)
	} else {
		var week = Number(selectWeek)+1
	}
	
	var newJsrow = {
		"rowId": "new_" + newRowCount,
		"week": week,
		"weight": defaultWeight,
		"visible": true,
		"product": {
			"id": products[ 0 ].id,
			"typeHandle": products[ 0 ].typeHandle,
			"sg": products[ 0 ].sg,
			"releaseProfile": products[ 0 ].releaseProfile,
			"nutrients": products[ 0 ].nutrients
		}
	};

	jsApplications.push( newJsrow );

	chartData = runTheNumbers();

	updateChart( chartData );

	addRowToDataTable(html,newRowCount);

	updateRows();

	newRowCount ++;

}
///////////////////////////////////

export function duplicateRows( products, data ) {

	//return console.log(data)

	$('#save-scenario').addClass('dirty');

	var entryId = $('input[name="entryId"]').val()
	var showPricing = $('.show-pricing-hidden').val()
	var units = $('.units-hidden').val()
	var defaultWeight = data.rate;
	var selectWeek = Number(data.week) + Number(data.interval) - 1
	var sortWeek = selectWeek + 1

	if (sortWeek.toString().length == 1) {
    	sortWeek = "0" + sortWeek;
  	}

	for (var z = 0; z < data.copies; z++) {

		if (selectWeek < 52) {

			// build the new row html. whew. hold tight.

			var html = '<tr id="new_' + newRowCount + '">';
			html += '<td class="revealer"></td>';
			html += '<input type="hidden" name="fields[applicationsMatrix][new_' + newRowCount + '][type]" value="' + products[0].typeHandle + '">';
			html += '<input type="hidden" name="fields[applicationsMatrix][new_' + newRowCount + '][enabled]" value="1">';
			html += '<td data-order="'+sortWeek+'">';
			html += '<select class="product-week-select select-two" name="fields[applicationsMatrix][new_' + newRowCount + '][fields][week]">';

			for ( var i = 0; i < weeksArray.length; i ++ ) {

				var week = weeksArray[ i ];

				if ( i == selectWeek ) { // 0 index

					html += '<option value="' + ( i + 1 ) + '" selected>' + week + '</option>'; // there is no week 0

				} else {

					html += '<option value="' + ( i + 1 ) + '">' + week + '</option>'; // there is no week 0

				}

			}

			html += '</select>';
			html += '</td>';
			html += '<td class="product-type">' + ( products[0].type == "Foliar SG" ? 'Foliar' : products[0].type ) + '</td>';
			html += '<td align="left">';
			html += '<div class="visible-md-up">'
			html += '<select class="product-select select-two" data-placeholder="Select A Product..." data-product-type="' + products[0].typeHandle + '">';

			html += '<option></option>';

			for ( var q = 0; q < products.length; q ++ ) {

				if ( products[ q ].id == data.productId ){
					var thisProduct = products[ q ]
					var newRow = false
					html += '<option value="' + products[ q ].id + '" data-product-price="' + products[ q ].price + '" selected>' + products[ q ].linkCode + '</option>';
					break;
				} else {
					var thisProduct = products[ 0 ]
					var newRow = true
					html += '<option value="' + products[ q ].id + '" data-product-price="' + products[ q ].price + '">' + products[ q ].linkCode + '</option>';
				}

			}

			console.log(thisProduct)

			if ( units == "imperial" ) {

				switch ( thisProduct.typeHandle ) {

					case "granular":
						var weightUnit = "lbs/1000 ft<sup>2</sup>";
						break;
					case "foliar":
					case "tankMix":
						var weightUnit = "oz/1000 ft<sup>2</sup>";
						break;
					case "foliarSg":
						var weightUnit = "lbs/acre";
						break;

				}

			} else {

				switch ( thisProduct.typeHandle ) {

					case "granular":
						var weightUnit = "kg/100m<sup>2</sup>";
						break;
					case "foliar":
					case "tankMix":
						var weightUnit = "l/ha";
						break;
					case "foliarSg":
						var weightUnit = "kg/ha";
						break;

				}

			}


			html += '</select>';
			html += '</div>'
			html += '<input type="hidden" class="product-id-row-new_' + newRowCount + '" name="fields[applicationsMatrix][new_' + newRowCount + '][fields][product][]" value="' + thisProduct.id + '">';
			html += '<div class="read-only-details visible-md-down">'+
								'<div class="product-week">'+weeksArray[selectWeek]+'</div>'+
								'<div class="product-title">'+thisProduct.linkCode+'</div>'+
								'<div class="product-type">'+ ( thisProduct.type == "Foliar SG" ? 'Foliar' : thisProduct.type ) +' - <span class="row-weight">'+defaultWeight+'</span> <span class="weight-unit">'+weightUnit+'</span></div>'+
							'</div>'

			html += '</div>';
			html += '</td>';

			console.log(thisProduct)

			// product info WRONG
			html += '<td class="product-info text-center">'
			html += '<span class="product-detail-title hidden">'+thisProduct.title+'</span>'
			html += '<span class="product-detail-description hidden">'+thisProduct.description+'</span>'
			html += '<span class="product-category hidden">'+thisProduct.productCategory+'</span>'
			html += '<span class="part-code hidden">' + (thisProduct.productCodeNew ? thisProduct.productCodeNew : "--" )+'</span>'
            html += '<span class="part-code-legacy hidden">' + (thisProduct.productCode ? thisProduct.productCode : "--" )+'</span>'
			html += '<span class="label-url hidden">' + thisProduct.labelUrl + '</span>'
			html += '<span class="product-weight hidden">' + thisProduct.weight + '</span>'
			html += '<span class="product-country hidden">'+ thisProduct.country +'</span>'
			html += '<span class="product-sgn hidden">'+thisProduct.sgn+'</span>'

			html += '<btn data-dismiss="modal" data-toggle="modal" data-target="#product-info-modal" class="btn btn-info btn-circle btn-product-info '+(!data.productId ? "disabled":"")+'"><i class="fas fa-info"></i></btn></td>';

			// rate // weight
			html += '<td><input type="text" min="0" class="row-weight-input" name="fields[applicationsMatrix][new_' + newRowCount + '][fields][weight]" size="4" value="' + defaultWeight + '"/> <span class="caption weight-unit">' + weightUnit + '</span></td>';

			// bags gallons
			html += '<td class="bags text-center" data-type="' + thisProduct.typeHandle + '" data-row-weight="' + defaultWeight + '" data-product-weight="' + thisProduct.weight + '"></td>';
			html += '<td class="gallons text-center" data-type="' + thisProduct.typeHandle + '" data-row-weight="' + defaultWeight + '">--</td>';

			// cost
			if ( showPricing=="1"){
			html += '<td class="text-center"><input type="text" min="0" class="row-price-input" name="fields[applicationsMatrix][new_' + newRowCount + '][fields][price]" size="5" value="' + data.price + '"/></td>'
			html += '<td class="cost text-center"></td>';
			}

			// NPK
			html += '<td class="nutrient nitrogen text-center" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.nitrogen + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '">--</td>';
			html += '<td class="nutrient phosphorous text-center" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.phosphorous + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '">--</td>';
			html += '<td class="nutrient potassium text-center" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.potassium + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '">--</td>';

			// hidden Nutrients
			html += '<input type="hidden" class="nutrient nitrogen" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.nitrogen + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
			html += '<input type="hidden" class="nutrient phosphorous" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.phosphorous + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
			html += '<input type="hidden" class="nutrient potassium" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.potassium + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
			html += '<input type="hidden" class="nutrient calcium" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.calcium + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
			html += '<input type="hidden" class="nutrient magnesium" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.magnesium + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
			html += '<input type="hidden" class="nutrient manganese" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.manganese + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
			html += '<input type="hidden" class="nutrient iron" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.iron + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
			html += '<input type="hidden" class="nutrient copper" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.copper + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
			html += '<input type="hidden" class="nutrient zinc" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.zinc + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '" value=""/>';
			html += '<input type="hidden" class="nutrient humic" data-type="' + thisProduct.typeHandle + '" data-amount="' + thisProduct.nutrients.humic + '" data-sg="' + thisProduct.sg + '" data-row-weight="' + defaultWeight + '" value=""/>';

			// controls
			html += '<td class="text-right controls">'
			html += '<btn data-entry-id="' + entryId + '" data-dismiss="modal" data-toggle="modal" data-target="#row-copy-modal" class="btn row-copy"><i class="far fa-copy"></i></btn> '
			html += '<i class="fas fa-eye toggle-row-visibility"></i> '
			html += '<btn class="btn btn-danger btn-circle row-delete"><i class="fas fa-times"></i></btn>'
			html += '</td>';

			html += '<input class="row-visible" type="hidden" name="fields[applicationsMatrix][new_' + newRowCount + '][fields][visible]" value="1"/>'

			html += '</tr>';

			// is the datatable "add products..." row showing? yes? remove it...
			if ( $('.dataTables_empty').length ) {
				$('.dataTables_empty').closest( "tr" ).remove();
			}

			// now update the scenario data and update the graph

			// week limit
			if ( Number(selectWeek) == 52 ) {
				var week = Number(selectWeek)
			} else {
				var week = Number(selectWeek)+1
			}
			
			var newJsrow = {
				"rowId": "new_" + newRowCount,
				"week": selectWeek,
				"weight": defaultWeight,
				"visible": true,
				"product": {
					"id": thisProduct.id,
					"typeHandle": thisProduct.typeHandle,
					"sg": thisProduct.sg,
					"releaseProfile": thisProduct.releaseProfile,
					"nutrients": thisProduct.nutrients
				}
			};

			jsApplications.push( newJsrow );

			addRowToDataTable(html,newRowCount);

			// counting
			newRowCount ++;
			selectWeek = selectWeek + Number(data.interval)
			sortWeek = selectWeek + 1

		}

	}

	chartData = runTheNumbers();

	updateChart( chartData );

	updateRows();

}

function addRowToDataTable(html,newRowCount){

	/// tip for adding links to dropdown items
	////http://jsfiddle.net/f8q2by55/

	var row = scenarioTableDT.row.add( $(html) );

	$('#scenario-table').DataTable().draw();

	$('#new_'+newRowCount+' .select-two').select2({
		width: '100%'
	})

}

function prePendDataTable(html){

	table = $("#scenario-table").dataTable() //not DataTable() function
	dt = table.api()
	dt.row.add( $(html) );
	var aiDisplayMaster = table.fnSettings()["aiDisplayMaster"];
	irow = aiDisplayMaster.pop();
	aiDisplayMaster.unshift(irow);
	dt.draw();

}

export function productRow(productSelect,productId,rowId){

	// set the value of the Craft input!
	$( ".product-id-row-" + rowId ).val( productId );

	$.getJSON( "/products.json", function(response) {

		var data = response.data;

		var row = $('#' + rowId)

		var product = data.filter(function( obj ) {
				return obj["id"] == productId;
		});
		product = product[0]

		var prevType = productSelect.attr('data-product-type')

		//toggle foliar weight-units

		if ( product.typeHandle == "foliar" && prevType == "foliarSg" ) {
			//console.log("Foliar selected, prev type SG.");
			row.find('.weight-unit').html('oz/1000 ft<sup>2</sup>')
			row.find('td.bags').attr('data-type','foliar')
			row.find('td.gallons').attr('data-type','foliar')
			row.find('input.nutrient').attr('data-type','foliar')
			row.find('td.nutrient').attr('data-type','foliar')
		}

		if ( product.typeHandle == "foliarSg" && prevType == "foliar") {
			//console.log("Foliar SG selected, prev type foliar.");
			row.find('.weight-unit').html('lbs/acre')
			row.find('td.bags').attr('data-type','foliarSg')
			row.find('td.gallons').attr('data-type','foliarSg')
			row.find('input.nutrient').attr('data-type','foliarSg')
			row.find('td.nutrient').attr('data-type','foliarSg')
		}

		// problematic when we come back from a modal
		if (!modalFlag) {
			row.find('.row-weight-input').val("0.0")
		}

		// change any hidden dispay here?
		row.find('.read-only-details .product-title').text( product.title )
		row.find('.read-only-details .row-weight').text( row.find('input.row-weight-input').val() )

		var sg = product.sg;
		var releaseProfile = product.releaseProfile;
		var nutrients = product.nutrients;
		var productWeight = product.weight;

		for ( var x = 0; x < jsApplications.length; x ++ ) {

			// mod the js row data

			if ( jsApplications[ x ][ "rowId" ] == rowId ) {

				jsApplications[ x ][ "product" ][ "id" ] = productId;
				jsApplications[ x ][ "product" ][ "sg" ] = sg;
				jsApplications[ x ][ "product" ][ "typeHandle" ] = product.typeHandle;
				jsApplications[ x ][ "product" ][ "nutrients" ] = nutrients;
				jsApplications[ x ][ "product" ][ "releaseProfile" ] = releaseProfile;
				jsApplications[ x ][ "weight" ] = row.find('input.row-weight-input').val();

			}

			// set the product type for the next change prevType
			productSelect.attr('data-product-type', product.typeHandle )

		}

		chartData = runTheNumbers();

		updateChart( chartData );

		// display
		row.find('.bags' ).attr( 'data-product-weight', productWeight );

		// populate the three big ones in the actual table row
		row.find('td.nitrogen' ).attr( 'data-amount', nutrients.nitrogen );
		row.find('td.phosphorous' ).attr( 'data-amount', nutrients.phosphorous );
		row.find('td.potassium' ).attr( 'data-amount', nutrients.potassium );

		// hidden (for calcs)
		row.find('.nutrient' ).attr( 'sg', sg );

		// populate all nutrients for THIS ROW. delivered. derived. not saved. #}
		row.find('input.nitrogen' ).attr( 'data-amount', nutrients.nitrogen );
		row.find('input.phosphorous' ).attr( 'data-amount', nutrients.phosphorous );
		row.find('input.potassium' ).attr( 'data-amount', nutrients.potassium );
		row.find('input.calcium' ).attr( 'data-amount', nutrients.calcium );
		row.find('input.magnesium' ).attr( 'data-amount', nutrients.magnesium );
		row.find('input.manganese' ).attr( 'data-amount', nutrients.manganese );
		row.find('input.iron' ).attr( 'data-amount', nutrients.iron );
		row.find('input.copper' ).attr( 'data-amount', nutrients.copper );
		row.find('input.zinc' ).attr( 'data-amount', nutrients.zinc );
		row.find('input.humic' ).attr( 'data-amount', nutrients.humic );

		// for the product-info modal data but general part / product code here
		row.find('span.product-detail-title').text( product.title );
		row.find('span.product-detail-description').text( product.description );
		row.find('span.product-category').text( product.productCategory );
		row.find('span.part-code').text( product.productCodeNew );
		row.find('span.label-url').text( product.labelUrl );
		row.find('span.product-weight').text( product.weight );
		row.find('span.product-weight-unit').text( product.country == "us" ? "lbs" : "kg" );
		row.find('span.product-sgn').text( product.sgn );
		
		updateRows();
		modalFlag = false

	});

}

// MOBILE modal ///////////////
export function addModalDataToRow(){

	var modal = $('.dtr-bs-modal')
	var rowId = modal.find('.dt-row-id').text()
	var row = $('#' + rowId)
	var productData = JSON.parse( $('.dtr-bs-modal .product-data').text() )

	// set the values on the modal inputs that matter
	// others are calculated. delayed. maybe too much?
	row.find(".select2-container").remove()


	var week = modal.find('.product-week-select').val()
	row.find('.product-week-select').val(week).select2({
		width: '100%',
		minimumResultsForSearch: 99999,
	}).trigger('change')
	row.find('.read-only-details .product-week').text( weeksArray[week-1] )

	var type = productData.typeHandle
	row.find('.product-select').attr('data-product-type', type)

	var productId = modal.find('.product-select').val()
	$('.dtr-bs-modal').find('.product-select').parent('div').addClass('visible-md-up')
	/// haaack. select leaves two containers behind. fix cause. someday.
	row.find('.product-select').val(productId).select2({
		width: "100%"
	}).trigger('change')

	var rate = modal.find('.row-weight-input').val()
	row.find('.row-weight-input').val(rate)

	var weightUnit = modal.find('.weight-unit').html()
	row.find('.read-only-details .weight-unit').html( weightUnit )
	row.find('span.caption.weight-unit').html( weightUnit )

	var price = modal.find('.row-price-input').val()
	row.find('.row-price-input').val(price)

}

function getPercentageFor(temp){

	if (temp < 0) {
		return 0;
	}

	if (temp > 110) {
		return 100;
	}

	// from ZERO F to 110 F
	var percentages = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,2,3,4,5,6,7,8,9,10,11,11,12,12,14,17,19,21,24,26,28,30,33,35,39,42,46,49,53,56,60,63,67,70,73,76,79,82,85,88,91,94,97,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100]
	return percentages[temp]

}

function latestWeek(){
	if ( $('.product-week-select').length ){
		var highestWeek = 0
		var weeks = $('.product-week-select');
		weeks.each( function(i){
			var tempWeek = $(weeks[i]).val()
			if ( Number(tempWeek) >= highestWeek ){
				highestWeek = tempWeek
			}
		})
		return Number(highestWeek)
	} else {
		return 9 // march 5, week 9 index zero
	}
}

function modalCalcs(){

	var units = $('.units-hidden').val();

	var modal = $('.dtr-bs-modal')
	var str = modal.find('.product-data').text()
	var product = JSON.parse(str)
	var rowWeight = modal.find('.row-weight-input').val()

	///////////////////////// BAGS

	if ( product.typeHandle == "granular" ) {

		// if ( units == "metric" ) {
		// 	rowWeight = rowWeight * 2.0482
		// }

		var bags = rowWeight * $( '#coverage' ).val() * 43.56 / product.weight;
		bags = round( bags, 0 );

	} else if ( product.typeHandle == "foliarSg" ) {

		// if ( units == "metric" ) {
		// 	rowWeight = rowWeight * .892179
		// }

		var lbssg = rowWeight / 43.56;
		lbssg = round( lbssg, 3 );
		var bags = lbssg * $( '#coverage' ).val() * 43.56 / product.weight;
		bags = round( bags, 0 );

	} else {

		var bags = "--";

	}

	modal.find("[data-dt-column='6'] td:nth-of-type(2)").text(bags);

	///////////////////////// GALLONSS

	if ( product.typeHandle == "foliar" || product.typeHandle == "tankMix" ) {

		// if ( units == "metric" ) {
		// 	rowWeight = rowWeight * .305151727
		// }

		var gallons = rowWeight * $( '#coverage' ).val() * 43.56 / 128;
		gallons = round( gallons, 0 );

	} else {

		var gallons = "--";

	}

	modal.find("[data-dt-column='7'] td:nth-of-type(2)").text(gallons);

	/// N P K

	//console.log(product);

	for ( i = 0; i < 3; i ++ ) {

		var nutrient

		i==0 ? nutrient = 'nitrogen' : null
		i==1 ? nutrient = 'phosphorous' : null
		i==2 ? nutrient = 'potassium' : null

		if ( product.typeHandle == "granular" ) {

			// if ( units == "metric" ) {
			// 	rowWeight = rowWeight * 2.0482
			// }

			var amount = rowWeight * product.nutrients[nutrient] / 100;
			amount = round( amount, 3 );

		} else if ( product.typeHandle == "foliar" || product.typeHandle == "tankMix" ) {

			// if ( units == "metric" ) {
			// 	rowWeight = rowWeight * .305151727
			// }

			var amount = ( rowWeight / 16 ) * product['sg'] * product.nutrients[nutrient] / 100;
			amount = round( amount, 3 );

		} else if ( product.typeHandle == "foliarSg" ) {

			// if ( units == "metric" ) {
			// 	rowWeight = rowWeight * .892179
			// }

			//var nutrient = ( rowWeight * .022956 ) * nutrientCell.data( 'sg' ) * nutrientCell.data( 'amount' ) / 100;
			var amount = ( rowWeight * .022956 ) * product.nutrients[nutrient] / 100;
			amount = round( amount, 3 );

		} else if ( product.typeHandle == "carryover" ) {

			amount = product.nutrients[nutrient];

		} else {

			var amount = "--";

		}

		i==0 ? modal.find("[data-dt-column='10'] td:nth-of-type(2)").text(amount) : null
		i==1 ? modal.find("[data-dt-column='11'] td:nth-of-type(2)").text(amount) : null
		i==2 ? modal.find("[data-dt-column='12'] td:nth-of-type(2)").text(amount) : null

	}


	//////////////////// COST

	var totalCost = 0;

		//var price = $( '#' + rowId + ' .product-select :selected' ).data( 'product-price' );
		var price = modal.find('.row-price-input' ).val();
		//var bags = $( '#' + rowId + ' .bags' ).html();
		//var gallons = $( '#' + rowId + ' .gallons' ).html();

		if ( bags != "--" ) {

			var cost = price * bags;

		}

		if ( gallons != "--" ) {

			var cost = price * gallons;

		}

		if ( cost ) {

			cost = round( cost, 2 );
			cost = formatDollar( cost );

		} else {

			cost = "--";

		}

		modal.find("[data-dt-column='9'] td:nth-of-type(2)").text(cost)

}

export function initDataTableCtrl(container) {

	/// tip for adding links to dropdown items
  	////http://jsfiddle.net/f8q2by55/

   $('.select-two',container).select2({
     width: '100%'
   });

   $('.select-two-no-search',container).select2({
     width: '100%',
     minimumResultsForSearch: 99999,
   });   

}

// PREP TABLES FOR PDF MAKE

export function parseAppTable(){

	var showPricing = $('.show-pricing-hidden').val()

	// PARSE AND PREP THE TABLE FOR THE PDF

	var appRows = {};
	var appFooterRows = {};
	var t = 0;
	var f = 0;

	$('#scenario-table tbody tr').each(function(){

			if ( !$(this).hasClass('hidden') ) {
				obj = this.children

				if (!appRows[t]) {
					appRows[t] = obj;
					t++
				}
			}

	});

	$('#scenario-table tfoot tr').each(function(){

		obj = this.children

		if (!appFooterRows[f]) {
			appFooterRows[f] = obj;
			f++
		}

	});

	var bigStack = [];

	if ( showPricing == "1") {
		var headerArray = [
							{text:'Week',style:'tableHeader'},
							{text:'Type',style:'tableHeader'},
							{text:'Product',style:'tableHeader'},
							{text:'Rate',style:'tableHeader'},
							{text:'Bags',style:'tableHeader',alignment:'center'},
							{text:'Gals',style:'tableHeader',alignment:'center'},
							{text:'Unit $',style:'tableHeader',alignment:'center'},
							{text:'Total $',style:'tableHeader',alignment:'center'},
							{text:'N',style:'tableHeader',alignment:'center'},
							{text:'P',style:'tableHeader',alignment:'center'},
							{text:'K',style:'tableHeader',alignment:'center'},
						]
	} else {
		var headerArray = [
							{text:'Week',style:'tableHeader'},
							{text:'Type',style:'tableHeader'},
							{text:'Product',style:'tableHeader'},
							{text:'Rate',style:'tableHeader'},
							{text:'Bags',style:'tableHeader',alignment:'center'},
							{text:'Gals',style:'tableHeader',alignment:'center'},
							{text:'N',style:'tableHeader',alignment:'center'},
							{text:'P',style:'tableHeader',alignment:'center'},
							{text:'K',style:'tableHeader',alignment:'center'},
						]
	}

	bigStack.push(headerArray);

	for(var row in appRows) {

		var stack = [];

		for ( var i = 0; i < appRows[row].length; i++) {

			var el = $(appRows[row][i])

			if ( !el.hasClass('revealer') && !el.hasClass('product-info') && !el.hasClass('controls') ) {

				if (el[0].tagName == "TD") {

					var obj = {};

					if ( el[0].children.length ) {

						// we have an input or a select to deal with

						var temp = el[0].children

						for ( var j = 0; j < temp.length; j++) {

							var tempEl  = $(temp[j])

							// we need to dodge the responsive wrapper and get at what's inside
							// this is almost certainly only for the Product column
							if ( tempEl[0].tagName == "DIV" && tempEl[0].classList.contains('visible-md-up') ) {
								var select = tempEl[0].children[0]
								if ( select ) {
									var index = tempEl[0].children[0].selectedIndex;
									obj.text = select.options[index].text;
								} else {
									obj.text = tempEl.text();
								}
							}


							if ( tempEl[0].tagName == "INPUT" && tempEl[0].classList.contains('row-weight-input') ) {

								var weight = $(tempEl[0]).val()

								// check for a superscript situation

								if ( el[0].innerText.indexOf('ft2') > -1 || el[0].innerText.indexOf('m2') > -1 ){

									// we have a superscript situation to... hack

									obj.columns = []

									// KEEP! reference
									// { columns: [
									// 	{text: 'line before superscript', width: 'auto'},
									// 	{text: 'superscript', width: 'auto', fontSize: 8}
									//  {text: 'line after superscript', width: 'auto'}
									// ]}

									var beforeSuperScript = weight + el[0].innerText.substr(0, el[0].innerText.indexOf('2'));

									var tempObj = {}
									tempObj.text = beforeSuperScript
									tempObj.width = 'auto'
									tempObj.fontSize = 7

									obj.columns.push(tempObj)

									var tempObj = {}
									tempObj.text = '2'
									tempObj.width = 'auto'
									tempObj.fontSize = 5

									obj.columns.push(tempObj)

								} else {

									obj.text = weight + el[0].innerText

								}

							}


							if ( tempEl[0].tagName == "INPUT" && tempEl[0].classList.contains('row-price-input') ) {
								obj.text = $(tempEl[0]).val()
								if ($(el[0])[0].className.indexOf("text-center") >= 0) {
									obj.alignment = 'center';
								} else {
									obj.alignment = 'left';
								}
							}


							if ( tempEl[0].tagName == "SELECT" ) {
								obj.text = tempEl[0].options[tempEl[0].selectedIndex].text
								if ($(el[0])[0].className.indexOf("text-center") >= 0) {
									obj.alignment = 'center';
								} else {
									obj.alignment = 'left';
								}
							}


						}

					} else {

						// straight up text

						var string = el[0].innerText
						string = string.replace(/(\n)+/g, '');

						obj.text = string;

						if ($(el[0])[0].className.indexOf("text-center") >= 0) {
							obj.alignment = 'center';
						} else {
							obj.alignment = 'left';
						}

					}

					stack.push(obj);

				}

			}

		}

		bigStack.push( stack );

	}

	for(var row in appFooterRows) {

		var stack = [];

		for (var i = 0; i < appFooterRows[row].length; i++) {
			var el = $(appFooterRows[row][i])

			if ( !el.hasClass('revealer') && !el.hasClass('product-info') && !el.hasClass('controls') ) {

				if (el[0].tagName == "TH" && $(el[0])[0].className != 'text-right controls') {

					var obj = {};

					var string = el[0].innerText
					string = string.replace(/(\n)+/g, '');


					if ( string != "Refresh") {

						obj.text = string;
						obj.style = 'bold';

						if ($(el[0])[0].className.indexOf("text-center") >= 0) {
							obj.alignment = 'center';
						} else {
							obj.alignment = 'left';
						}

					}



					stack.push(obj);

				}

			}

		}

		bigStack.push( stack );

	}

	return bigStack

}

export function parseNutrientTable(){

	// PARSE AND PREP THE TABLE FOR THE PDF

	var nutrientRows = {};
	var n = 0;

	$('.scenario-nutrient-table.large tbody tr').each(function(){

		obj = this.children

		if (!nutrientRows[n]) {
			nutrientRows[n] = obj;
			n++
		}

	});

	var bigStack = [];

	var headerArray = [
							{text:'N',style:'tableHeader',alignment:'center'},
							{text:'P',style:'tableHeader',alignment:'center'},
							{text:'K',style:'tableHeader',alignment:'center'},
							{text:'Ca',style:'tableHeader',alignment:'center'},
							{text:'Mg',style:'tableHeader',alignment:'center'},
							{text:'Mn',style:'tableHeader',alignment:'center'},
							{text:'Fe',style:'tableHeader',alignment:'center'},
							{text:'Cu',style:'tableHeader',alignment:'center'},
							{text:'Zn',style:'tableHeader',alignment:'center'},
							{text:'Humic',style:'tableHeader',alignment:'center'}
						]

	bigStack.push(headerArray);

	for( var row in nutrientRows) {

		var stack = [];

		for (var i = 0; i < nutrientRows[row].length; i++) {
			var el = $(nutrientRows[row][i])

			if (el[0].tagName == "TD") {

				var obj = {};

				if ( el[0].innerText.indexOf('ft2') > -1 || el[0].innerText.indexOf('m2') > -1 ){

					// we have a superscript situation to... hack

					obj.columns = []

					var split = el[0].innerText.split('2');
					var beforeSuperScript = split[0]
					var afterSuperScript = split[1]

					var tempObj = {}
					tempObj.text = beforeSuperScript
					tempObj.width = 'auto'
					//tempObj.style = 'bold'

					obj.columns.push(tempObj)

					var tempObj = {}
					tempObj.text = '2'
					tempObj.width = 'auto'
					tempObj.fontSize = 5
					//tempObj.style = 'bold'

					obj.columns.push(tempObj)

					var tempObj = {}
					tempObj.text = afterSuperScript
					tempObj.width = 'auto'
					//tempObj.style = 'bold'

					obj.columns.push(tempObj)

					// { columns: [
					// 	{text: 'line before superscript', width: 'auto'},
					// 	{text: 'superscript', width: 'auto', fontSize: 8}
					// ]}

				} else {

					var string = el[0].innerText
					string = string.replace(/(\n)+/g, '');

					obj.text = string;
					obj.fontSize = 7
					obj.alignment = 'center';

				}

				stack.push(obj);

			}

		}

		bigStack.push( stack );

	}

	return bigStack

}

// TOUR
export function startScenarioTour() {

	var table = $('#scenario-table').DataTable();

	if ( ! table.data().any() ) {
		var steps = [{
			element: document.querySelector('#add-a-product'),
			title: "Add a Product",
			intro: "To get the full benefit of this tour, use this button to add your first product to the scenario."
		}]
	} else {
		var steps = [{
			element: document.querySelector('#step1'),
			title: "Scenario Properties",
			intro: "This is a summary of your scenario's properties. Changes to <strong>Target N</strong>, <strong>Coverage</strong>, and <strong>Zone</strong> can be made here. <strong>Turf Type</strong> can only be adjusted by building a new scenario."
		  },{
			element: document.querySelector('#chart-legends'),
			title: "Chart Legend",
			intro: "<p>This legend explains the colors used on the chart below.</p> <p>Turf response to granular and foliar nitrogen applications is affected by cold temperatures.</p>"
		  },{
			element: document.querySelector('#chart-holder'),
			title: "Chart",
			intro: "Here, you'll see a graphical representation of your turf's response to applied nitrogen based on the products you've selected. Adding zero-nitrogen products to your scenario will not alter the release curve."
		  },{
			element: document.querySelector('#add-a-product'),
			title: "Add a Product",
			intro: "Use this button to add new products to your scenario."
		  },{
			element: document.querySelector('#scenario-table > tbody > tr:not(#row-carryover)'),
			title: "Product Schedule",
			intro: 'This is the heart of your scenario, where you\'ll build your season-long or in-season program, including fertilizers, control products, and soil amendments. Use the <btn class="btn btn-info btn-circle btn-product-info"><i class="fas fa-info"></i></btn> to explore Product Info, including product labels.'
		  },{
			element: document.querySelector('#scenario-table > tbody > tr:not(#row-carryover)'),
			title: "Product Rows",
			intro: '<p>Input <strong>Week</strong> and <strong>Rate</strong> to calculate N-P-K delivered and populate Nitrogen release curve above. Use the <strong>Replicate</strong> <i class="far fa-copy"></i>, <strong>Hide</strong> <i class="fas fa-eye"></i>, and <strong>Delete</strong> <btn class="btn btn-danger btn-circle"><i class="fas fa-times"></i></btn> buttons to simplify scenario building.</p><p>Remember, zero-nitrogen products (0-0-12, Humic DG, etc.) will not alter the Nitrogen release curve.</p>',
			position: 'right'
		  },{
			element: document.querySelector('.summary-wrapper'),
			title: "Summary",
			intro: "Here, you'll see a summary of all products included in your scenario."
		  },{
			element: document.querySelector('.scenario-nutrient-table'),
			title: "Seasonal Nutrients Delivered",
			intro: "This table summarizes the total nutrients your scenario delivers over the course of the year."
		  },{
			element: document.querySelector('#notes'),
			title: "Notes",
			intro: "Use this section to highlight strategies, product combinations, and other important information about this particular scenario."
		  },{
			element: document.querySelector('.btn-make-pdf'),
			title: "Download PDF",
			intro: "Save your scenario to a PDF and share with others."
		},{
			element: document.querySelector('#goodbye'),
			title: "Thanks!",
			intro: "<p>That's it for the tour. You can replay the whole tour any time by clicking on the <strong>View Tour</strong> button at the top of this page.</p><p>To begin building scenarios of your own, use the <strong>Menu</strong> button to return to your <strong>Dashboard</strong>.</p>"
		}]
	}
	
	var tourOptions = {
	  disableInteraction: true,
	  exitOnOverlayClick: false,
	  showBullets: false,
	  showStepNumbers: true,
	  overlayOpacity: .66,
	  nextToDone: true,
	  hidePrev: true,
	  steps: steps,
	  scrollToElement: true
	}

	introJs.tour().setOptions(tourOptions).start()
	
	// .oncomplete(function() {
	// 	sessionStorage.newUser = false;
	// });

}

/// intro.js hints
var doc = $(document)
doc.on( 'change', '#toggle-hints', function(){

	console.log("toggling hints");

  var hints = [{
    element: document.querySelector('#produces-carryover'),
    hint: '<p>A yellow dot shown here indicates that a given scenario has nitrogen applied toward the end of the current year that would carry over into the following year.</p><p>To build a new scenario utilizing this carryover, choose the <strong>Replicate w/ Carryover</strong> option.</p>', 
    hintPosition: 'middle-left'
  },{
    element: document.querySelector('#utilizes-carryover'),
    hint: '<p>A yellow dot shown here indicates that a given scenario utilizes the carryover from a previous scenario.</p>', 
    hintPosition: 'middle-left'
  },{
    element: document.querySelector('#title'),
    hint: 'Click here to edit, replicate or delete a scenario. ', 
    hintPosition: 'middle-middle'
  },{
    element: document.querySelector('#show-pricing'),
    hint: 'Check the <strong>Show Pricing</strong> checkbox to enable pricing columns on a given scenario. These checkboxes will appear blank, allowing you input your own pricing.', 
    hintPosition: 'middle-left'
  },{
    element: document.querySelector('#user-scenarios-table_filter'),
    hint: 'Once you\'ve accumulated several scenarios, use this <strong>Search</strong> box to filter in real time and more quickly locate a given scenario.', 
    hintPosition: 'middle-right'
  }]
  
  
  

  if ($(this).is(":checked")) {
	console.log("showing hints");
    introJs.hint().setOptions({
      hints: hints
    }).showHints()
  } else {
	console.log("hiding hints");
	let containers = document.querySelectorAll(".introjs-hint");
	containers.forEach(container => {
		// remove the hint element from the DOM
		container.remove();
	});
  }

})

// UNIT conversions

function nReleaseToMetric(data) {

	var converted = [];

	for ( var i = 0; i < data.length; i ++ ) {
		var datum = data[i];
		var newdatum = datum * .488242764;
		newdatum = round(newdatum,3);
		converted.push( newdatum );

		// note: * 2.0482 for metric to empire, g/m^2 > lbs/1000ft^2	( 1/4.882335709403379  )
		// note: * .20482 for metric to empire, kg/100m^2 > lbs/1000ft^ (1/.488242764)

	}

	return converted;

}
